import * as Yup from "yup"

import { tenantOptions } from "constants/bonus"

export const adminCreateUserSchema = Yup.object({
  username: Yup.string()
    .required("Username is required")
    .min(2)
    .max(16)
    .matches(/^[a-z](?:[a-z0-9]|[-_.](?=[a-z0-9])){1,15}$/i, "Start with a letter, can include alphanumeric, _, -, or dot."),
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string().required("Password is required").min(8, "Password must be at least 8 characters"),
  phoneNumber: Yup.string().required("Phone number is required"),
  country: Yup.string().required("Country is required"),
  tenantId: Yup.string()
    .oneOf(
      tenantOptions.map((t) => t.value),
      "Invalid tenant"
    )
    .required("Tenant is required"),
  siteLang: Yup.string().optional(),
  role: Yup.string().optional()
})
